import React from "react";
import CheckoutShippingRatesPickers from "components/CheckoutShippingRatesPickers";
import { useFormikContext } from "formik";

const ShippingRatesFields = ({ showEmptyCopy }) => {
  const { values } = useFormikContext();
  const canEdit = !Boolean(values.id);

  return (
    <CheckoutShippingRatesPickers
      showEmptyCopy={showEmptyCopy}
      rootPath="data.product"
      name="checkout.shipping_options"
      editMode={canEdit}
    />
  );
};

export default ShippingRatesFields;
